import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Design.css'; // CSS 파일 임포트
import moment from 'moment';
const API_KEY = process.env.REACT_APP_API_KEY;
const fetchSchoolInfo = async (schoolName) => {
  try {
    const response = await axios.get(
      `https://open.neis.go.kr/hub/schoolInfo?KEY=${API_KEY}&Type=JSON&SCHUL_NM=${schoolName}`
    );
    return response.data;
  } catch (error) {
    console.error("학교 정보를 불러오지 못했습니다.", error);
    return null;
  }
};

const fetchMealData = async (schoolCode, eduCode, date) => {
  try {
    const formattedDate = date.replace(/-/g, '');
    const response = await axios.get(
      `https://open.neis.go.kr/hub/mealServiceDietInfo?KEY=${API_KEY}&Type=JSON&ATPT_OFCDC_SC_CODE=${eduCode}&SD_SCHUL_CODE=${schoolCode}&MLSV_YMD=${formattedDate}`
    );
    return response.data;
  } catch (error) {
    console.error("급식 데이터를 불러오지 못했습니다.", error);
    return null;
  }
};
// 주어진 날짜의 해당 주 월요일부터 금요일까지의 날짜를 반환하는 함수
const getWeekDates = (currentDate) => {
  const date = moment(currentDate);
  const day = date.day(); // 0: 일요일, 1: 월요일, ..., 6: 토요일

  let startDate = date.clone();
  if (day === 6) { // 토요일
      startDate.add(2, 'days'); // 다음 주 월요일
  } else if (day === 0) { // 일요일
      startDate.add(1, 'days'); // 다음 주 월요일
  }

  const weekDates = [];
  for (let i = 0; i < 5; i++) {
      weekDates.push(startDate.clone().add(i, 'days').format('YYYY-MM-DD'));
  }

  return weekDates;
};
const replaceLineBreaks = (text) => {
  return text.replace(/<br\s*\/?>/gi, '\n');
};

const formatSchoolName = (schoolName, location) => {
  return schoolName + (location ? ` (${location})` : '');
};

const SchoolMealPage = () => {
  const [schoolName, setSchoolName] = useState('');
  const [schoolList, setSchoolList] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [mealData, setMealData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false); // 쿠키 동의 팝업 상태
  const [isAgreed, setIsAgreed] = useState(false); // 쿠키 동의 여부

  const searchSchool = async () => {
    if (schoolName === '') return;
    const schoolInfo = await fetchSchoolInfo(schoolName);
    if (schoolInfo && schoolInfo.schoolInfo && schoolInfo.schoolInfo[1].row) {
      setSchoolList(schoolInfo.schoolInfo[1].row);
    } else {
      setSchoolList([]);
    }
  };

  const fetchMeals = async () => {
    if (!selectedSchool || Object.keys(mealData).length > 0) return; // 이미 급식 데이터를 불러온 경우 다시 요청하지 않음
    setLoading(true);
    const { SD_SCHUL_CODE, ATPT_OFCDC_SC_CODE } = selectedSchool;

    const weekDates = getWeekDates(new Date());
    const meals = {};

    for (let date of weekDates) {
      const mealInfo = await fetchMealData(SD_SCHUL_CODE, ATPT_OFCDC_SC_CODE, date);
      if (mealInfo && mealInfo.mealServiceDietInfo && mealInfo.mealServiceDietInfo[1]) {
        const mealsForDate = mealInfo.mealServiceDietInfo[1].row.map((item) => replaceLineBreaks(item.DDISH_NM));
        meals[date] = mealsForDate;
      } else {
        meals[date] = ['급식 정보가 없습니다.'];
      }
    }

    console.log("Fetched Meals: ", meals); // 급식 데이터를 제대로 불러왔는지 확인
    setMealData(meals); // 급식 데이터 상태에 저장
    setLoading(false);
  };

  const handleSchoolSave = () => {
    if (!isAgreed) {
      // 로컬 스토리지 저장 동의 여부 확인
      const userAgreed = window.confirm('이 사이트는 로컬 스토리지를 사용하여 정보를 저장합니다. 동의하시겠습니까?');
      if (!userAgreed) {
        alert('로컬 스토리지 저장에 동의하지 않으면 학교 정보를 저장할 수 없습니다.');
        return;
      }
  
      setIsAgreed(true);
      // 동의 여부 로컬 스토리지에 저장
      localStorage.setItem('storageAgreement', 'true');
    }
  
    // 학교 정보 저장
    localStorage.setItem('selectedSchool', JSON.stringify(selectedSchool));
    alert('학교 정보가 로컬 스토리지에 저장되었습니다.');
  };
  
  
  const checkStoredSchool = () => {
    const storedSchool = localStorage.getItem('selectedSchool');
    if (storedSchool) {
      setSelectedSchool(JSON.parse(storedSchool));
    }
  };
  
  const checkCookieAgreement = () => {
    return localStorage.getItem('cookieAgreement') === 'true';
  };
  

  useEffect(() => {
    if (!checkCookieAgreement()) {
      setIsPopupVisible(true); // 쿠키 동의 팝업을 보여줍니다.
    }
    checkStoredSchool(); // 페이지 로드 시 저장된 학교 정보 확인
  }, []);

  useEffect(() => {
    if (selectedSchool) {
      fetchMeals(); // selectedSchool이 변경될 때마다 급식 데이터 가져오기
    }
  }, [selectedSchool]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchSchool();
    }
  };

  return (
    <div className="container">
      <div className="navbar">
        <div className="school-info">스쿨리오</div>
        <div className="menu">
          <a href="/school-meal">급식 메뉴</a>
          <a href="/schedule">학사일정</a>
          <a href="/timetable">시간표 보기</a>
        </div>
      </div>

      <h2 className="header">학교 급식 조회</h2>
      <div className="search-box">
        <input
          type="text"
          value={schoolName}
          onChange={(e) => setSchoolName(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="학교 이름을 입력하세요"
        />
        <button onClick={searchSchool}>🔍</button>
      </div>

      {schoolList.length > 0 && (
        <ul className="school-list">
          {schoolList.map((school, index) => (
            <li key={index} onClick={() => setSelectedSchool(school)}>
              {formatSchoolName(school.SCHUL_NM, school.ATPT_OFCDC_SC_NM)}
            </li>
          ))}
        </ul>
      )}

      {selectedSchool && (
        <div className="meal-info">
          <h3>{selectedSchool.SCHUL_NM}의 급식 정보</h3>
          {loading ? (
            <div className="spinner"></div>
          ) : (
            <table className="meal-table">
              <thead>
                <tr>
                  <th>월</th>
                  <th>화</th>
                  <th>수</th>
                  <th>목</th>
                  <th>금</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {getWeekDates(new Date()).map((date, idx) => (
                    <td key={idx}>
                      <pre>{mealData[date] ? mealData[date].join("\n") : '급식 정보가 없습니다.'}</pre>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          )}

          <button onClick={handleSchoolSave}>학교 저장</button>
        </div>
      )}
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6743303187786941"
          crossorigin="anonymous"></script>
      
      <ins class="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-6743303187786941"
          data-ad-slot="1132804606"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      <script>
          (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
      <p>ChatGPT와 함께 만들었습니다</p>
      <p>나이스 교육정보 개방포털 API를 사용하여 만들었습니다</p>
      <p>
        <a href="https://forms.gle/7c67TdpFS5SLtVeu6" target="_blank" class="footer-link">오류제보</a> • 
        <a href="mailto:hamin120207@naver.com" class="footer-link"> 문의</a>
      </p>
    </div>
  );
};

export default SchoolMealPage;